// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TbUtils14 from "./TbUtils14.bs.js";
import * as TeamPlannerHex14 from "./TeamPlannerHex14.bs.js";

function HexPreview14(Props) {
  var unitId = Props.unitId;
  var unitItems = Props.unitItems;
  var starLevel = Props.starLevel;
  var traitCounts = Props.traitCounts;
  var exaltedUnits = Props.exaltedUnits;
  return React.createElement("g", {
              transform: "translate(3, 0)"
            }, React.createElement("g", {
                  className: "scale-50 sm:scale-100"
                }, React.createElement(TeamPlannerHex14.Unit.make, {
                      isDragging: false,
                      hexSize: 50,
                      hex: {
                        unit: TbUtils14.Content.decodeStr(unitId),
                        items: unitItems,
                        starLevel: starLevel,
                        chosenTrait: 0
                      },
                      colNum: 0,
                      rowNum: 0,
                      onRemove: (function (param) {
                          
                        }),
                      onRemoveItem: (function (param, param$1, param$2) {
                          
                        }),
                      onSetStarLevel: (function (param, param$1, param$2) {
                          
                        }),
                      onToggleMech: (function (param, param$1, param$2) {
                          
                        }),
                      traitCounts: traitCounts,
                      exaltedUnits: exaltedUnits
                    })));
}

var make = React.memo(HexPreview14);

export {
  make ,
  
}
/* make Not a pure module */
